import React, { useState, useEffect, useCallback } from "react";
import { getbarbers } from "../../api/barberApi.jsx";
import {
  getAppointmentsByFillter,
  updateAppointmentStatus,
  reassignAppointmentCustomer,
} from "../../api/appointmentApi.jsx"; // fake API call
import { getAllCustomer } from "../../api/customerApi.jsx";
import { BookingStatus } from "../../components/BookingStatus";
import { useAuth } from "../../context/AuthContext";

const useAppointmentsManagement = () => {
  const { user } = useAuth();

  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  const [reference, setReference] = useState("");
  const [selectCustomer, setSelectCustomer] = useState(null);
  const [customerList, setCustomerList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState();
  const [statusList, setStatusList] = useState();

  const [selectedBarber, setSelectedBarber] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [updateAppointment, setUpdateAppointment] = useState({});
  const [showUpdateAppointment, setShowUpdateAppointment] = useState(false);

  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [barberList, setBarberList] = useState([]);

  useEffect(() => {
    const fetchBarbers = async () => {
      try {
        const result = await getbarbers(user.barberShop);

        if (result) {
          var barberlist = result.map((b) => ({
            id: b.id,
            name: b.name,
          }));

          barberlist.unshift({
            id: null,
            name: "----All----",
          });

          setBarberList(barberlist);
          setSelectedBarber(barberlist[0]);
        }
      } catch (err) {
        console.error("Error fetching appointments:", err);
      }
    };
    const fetchCustomers = async () => {
      try {
        const result = await getAllCustomer(user.barberShop);

        if (result) {
          var customerList = result.map((b) => ({
            id: b.id,
            name: b.name,
          }));

          customerList.unshift({
            id: null,
            name: "----Any----",
          });

          setCustomerList(customerList);
          setSelectCustomer(customerList[0]);
        }
      } catch (err) {
        console.error("Error fetching appointments:", err);
      }
    };
    setStatusList(BookingStatus);
    setSelectedStatus(BookingStatus[0]);
    fetchBarbers();
    fetchCustomers();
  }, []);
  const fetchAppointments = async () => {
    try {
      const result = await getAppointmentsByFillter(
        user.barberShop,
        date,
        selectedBarber?.id,
        selectCustomer?.id,
        selectedStatus?.id,
        reference.trim(),
      );

      setAppointments(result);
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };
  useEffect(() => {
    fetchAppointments();
  }, [selectedBarber, selectedStatus, date, selectCustomer]);

  useEffect(() => {
    if (reference.length >= 2) {
      fetchAppointments();
    }
  }, [reference]); // re-run when reference changes
  const onEditClick = (appointment) => {
    // Find customer by name
    const matchedCustomer = customerList.find(
      (c) => c.name === appointment.client,
    );
    const matchedstatus = BookingStatus.find(
      (s) => s.name == appointment.status,
    );
    const appt = {
      ...appointment,
      client: matchedCustomer ? matchedCustomer.id : null,
      status: matchedstatus,
    };

    setUpdateAppointment(appt);
    setShowUpdateAppointment(true);
  };
  const onSaveClick = async (appt) => {
    var oldAppointment = updateAppointment;
    var updateSuccess = false;
    setUpdateAppointment(null);
    setShowUpdateAppointment(false);
    if (appt.status != oldAppointment.status) {
      var response = await updateAppointmentStatus(
        user.barberShop,
        appt.id,
        appt.status.id,
        appt.startTime,
        appt.endTime,
      );

      if (response.data.isSuccess) {
        updateSuccess = true;
        setMessage({ text: response.data.value, type: "success" });
        setShowMessage(true);
        await new Promise((resolve) => setTimeout(resolve, 3000));
      } else {
        setMessage({
          text: response?.data.errors?.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
        await new Promise((resolve) => setTimeout(resolve, 3000));
      }
    }
    if (appt.client != oldAppointment.client) {
      var result = await reassignAppointmentCustomer(
        user.barberShop,
        appt.id,
        appt.client,
      );

      if (result.data.isSuccess) {
        setMessage({ text: result.data.value, type: "success" });
        setShowMessage(true);
      } else {
        setMessage({
          text: result?.data.errors?.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
      }
    }
    fetchAppointments();
  };
  const onCloseUpdateAppointment = () => {
    setUpdateAppointment(null);
    setShowUpdateAppointment(false);
  };

  return {
    barberList,
    selectedBarber,
    selectedStatus,
    selectCustomer,
    reference,
    customerList,
    date,
    appointments,
    statusList,
    showMessage,
    setShowMessage,
    message,
    setSelectedStatus,
    setSelectCustomer,
    setSelectedBarber,
    setReference,
    setDate,
    fetchAppointments,
    onEditClick,
    updateAppointment,
    onCloseUpdateAppointment,
    showUpdateAppointment,
    onSaveClick,
  };
};
export default useAppointmentsManagement;
